import ApiService from "@/core/services/api.service";

const ChatService = {
  getSummary() {
    return ApiService.get("chat/summary");
  },

  getSources() {
    return ApiService.get("chat/sources");
  },

  getWaitingSessions(params = {}) {
    return ApiService.query("chat/sessions/waiting", params);
  },

  getActiveSessions(params = {}) {
    return ApiService.query("chat/sessions/active", params);
  },

  getHistorySessions(params = {}) {
    return ApiService.query("chat/sessions/history", params);
  },

  getSession(id) {
    return ApiService.get("chat/sessions", id);
  },

  acceptSession(id) {
    return ApiService.post(`chat/sessions/${id}/accept`, {});
  },

  sendMessage(id, data) {
    return ApiService.post(`chat/sessions/${id}/message`, data);
  },

  closeSession(id) {
    return ApiService.post(`chat/sessions/${id}/close`, {});
  },

  markSessionRead(id) {
    return ApiService.post(`chat/sessions/${id}/mark-read`, {});
  },

  getOperatorStatus() {
    return ApiService.get("chat/operator/status");
  },

  setOnline() {
    return ApiService.post("chat/operator/online", {});
  },

  setOffline() {
    return ApiService.post("chat/operator/offline", {});
  },

  touch() {
    return ApiService.post("chat/operator/touch", {});
  },

  markHistorySessionRead(id) {
    return ApiService.post(`chat/sessions/${id}/history-mark-read`, {});
  },

  autoOnline() {
    return ApiService.post("chat/operator/auto-online", {});
  },

  touchOperator(params = {}) {
    return ApiService.post("chat/operator/touch", params);
  },

  setOperatorOnline() {
    return ApiService.post("chat/operator/online", {});
  },

  setOperatorOffline() {
    return ApiService.post("chat/operator/offline", {});
  },
  
  getQuickReplies(params = {}) {
    return ApiService.query('chat/admin/quick-replies', { params });
  },

  getQuickRepliesManage(params = {}) {
    return ApiService.query('chat/admin/quick-replies/manage', { params });
  },

  createQuickReply(data) {
    return ApiService.post('chat/admin/quick-replies', data);
  },

  updateQuickReply(id, data) {
    return ApiService.update('chat/admin/quick-replies', id, data);
  },

  deleteQuickReply(id) {
    return ApiService.delete('chat/admin/quick-replies/' + id);
  },

  getTranslatorUsage(params = {}) {
    return ApiService.query('chat/admin/translator-usage', { params });
  },
};

export default ChatService;